import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import Heading from 'LuxKit/Typography/Heading'
import { getRecommendationsTitle } from './utils/recommendationsTitle'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'

const Root = styled.div`
  text-align: center;
`

interface Props {
  checkIn: string
  monthIndex: string
  duration: number
  offerIds: Array<string>
  loadingState: App.ApiResponseState
}

function CalendarPickerRecommendationsHeading({
  checkIn,
  monthIndex,
  duration,
  offerIds,
  loadingState,
}: Props) {
  const intl = useIntl()

  const { title, subtitle } = useMemo(() => getRecommendationsTitle({
    checkIn,
    monthIndex,
    duration,
    intl,
  }), [checkIn, duration, monthIndex, intl])

  const readyToDisplay = loadingState === 'done' && offerIds.length > 0

  if (!readyToDisplay) {
    return null
  }
  return <Root>
    {title && <Heading variant="heading3" align="center">{title}</Heading>}
    {subtitle && <BodyText variant="small">{subtitle}</BodyText>}
  </Root>
}

export default withOfferPageAndReduxState((state, appState) => ({
  duration: state.duration,
  monthIndex: state.recommendationsMonthIndex,
  checkIn: state.recommendationsCheckInDay,
  offerIds: appState.recommendations.calendarRecommendations.offerIds,
  loadingState: appState.recommendations.calendarRecommendations.state,
}), CalendarPickerRecommendationsHeading)
